/**
 * Feature flags frontend.
 *
 * Faza 2 — wizard-ul de 15 pași și modulele de flux clinic sunt ascunse în spatele
 * feature flag-ului `VITE_FEATURE_CLINICAL_WORKFLOW` (implicit dezactivat).
 *
 * Valoarea se citește la build time (Vite înlocuiește `import.meta.env.*` cu
 * constanta din bundle), deci se activează cu:
 *   VITE_FEATURE_CLINICAL_WORKFLOW=true npm run build --workspace=@hepaderm/frontend
 */
export const features = {
  clinicalWorkflow: import.meta.env.VITE_FEATURE_CLINICAL_WORKFLOW === 'true',
};

export type Features = typeof features;
